import { render, staticRenderFns } from "./NavbarDesktop.vue?vue&type=template&id=5410bd2c&scoped=true"
import script from "./NavbarDesktop.vue?vue&type=script&lang=js"
export * from "./NavbarDesktop.vue?vue&type=script&lang=js"
import style0 from "./NavbarDesktop.vue?vue&type=style&index=0&id=5410bd2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5410bd2c",
  null
  
)

export default component.exports